
export const callStatus = {
    our_flat: 2,
    not_our: 4,
    agent: 5,
    not_callable: 3,
    not_first: 6
}